<template>
  <div :class="[appEnv != 'fgy' ? 'pro-select-wrapper' :'pro-select-wrapper1' ,{'pro-select-wrapper-folding': folding}]">
    <div class="pro-select-contents">
      <a
        class="m-pro-ttip"
        @click="handleExpand"
        :class="{'m-pro-ttip-active': expanded}"
      >
        <span
          class="dot-ent-name1"
          v-show="!folding"
        >{{curMchInfo&&curMchInfo.mchName}}</span>
        <a-icon
          type="swap"
          v-show="mchList.length>1"
        />
      </a>
    </div>
    <div
      class="pro-drop-wrapper"
      :class="{'pro-drop-wrapper-folding': folding}"
      v-show="expanded"
      ref="mchDropRef"
    >
      <div class="pro-search-header">
        <a-input-search
          placeholder="请搜索"
          class="ent-search"
          v-model="searchName"
          @search="fetchMch"
        />
      </div>
      <ul
        class="pro-list"
        v-if="mchList.length"
      >
        <li
          class="ent-m-item"
          :class="{'ent-m-item-active':currentSelectId==ent.id}"
          v-for="ent in mchList"
          :key="ent.id"
          @click="clickItem($event,ent)"
        >{{`${ent.mchNo + '(' + ent.mchName + ')'}`}}</li>
      </ul>
      <div
        class="no-project-data"
        v-else
      >
        暂无数据
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { queryMchList } from '@/api/projectTree'
import { setStore, getStore } from '@/utils/storage'
import { event } from "@ice/stark-data";
export default {
  props: {
    showVisible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(['entInfo', 'isProjectShow', 'folding'])
  },
  watch: {
    showVisible (newV, oldV) {
      if (newV) {
        this.isSelect = true
        this.fetchProjectList()
        this.fetchMchList()
      }
    },
    'entInfo.id': {
      handler (newV) {
        if (newV) {
          this.isSelect = true
          this.fetchMchList()
        }
      },
      deep: true
    }
  },
  data () {
    return {
      searchName: '',
      mchList: [],
      isSelect: false,
      isInit: true,
      currentSelectId: '',
      expanded: false,
      curMchInfo: null,
      projectDropRef: null,
      appEnv: '', //项目标识符
    }
  },
  mounted () {
    this.isSelect = true
    this.isInit = true
    this.initMEvent()
    this.$nextTick(() => {
      this.initDomEvent()
    })
    this.fetchMchList()
    this.appEnv = process.env.VUE_APP_ENV
  },
  methods: {
    initDomEvent () {
      document.addEventListener('click', (e) => {
        if (this.$refs.mchDropRef) {
          const isSelf = this.$refs.mchDropRef.contains(e.target)
          if (!isSelf) {
            this.expanded = false
            // this.$store.commit('SEARCH_MCH', false)
          }
        }
      })
    },
    initMEvent () {
      event.on('refreshMch', (item) => {
        if (item && item != "undefined") {
          setStore('mchInfo', JSON.stringify(item))
          this.currentSelectId = item.mchNo
          this.curMchInfo = item
          this.$emit('chooseMch', item, this.mchList)
          this.$emit("closeMchSelect", false);
          this.$store.commit('SET_MCHINFO', item);
          this.$actions.setGlobalState({ mchInfo: item });
          this.searchName = ''
        } else {
          const mMchInfo = {
            mchName: null,
            mchNo: null,
            id: null,
            enterpriseCode: null,
            enterpriseName: null,
            keywords: null,
            status: null,
            type: null
          }
          this.mchList = []
          setStore('mchInfo', JSON.stringify(mMchInfo))
          this.$store.commit("SET_MCHINFO", mMchInfo);
          this.$actions.setGlobalState({
            mchInfo: mMchInfo
          });
        }

      })
    },
    async fetchMchList (isSearch) {
      if (this.entInfo.id) {
        const param = {
          enterpriseCode: this.entInfo.code,
          keywords: this.searchName
        }
        console.log(param, '获取商户时的接口参数数据', this.entInfo)
        try {
          const { code, data } = await queryMchList(param)
          if (code === 0) {
            if (Array.isArray(data) && data.length > 0) {
              this.mchList = data?.map((o) => {
                return {
                  mchName: o.mchName,
                  mchNo: o.mchNo,
                  id: o.id,
                  enterpriseCode: o.enterpriseCode,
                  enterpriseName: o.enterpriseName,
                  status: o.status,
                  type: o.type
                }
              }) || []
              if (this.mchList.length && this.isSelect && !isSearch) {
                const savedMchInfo = JSON.parse(getStore('mchInfo'))
                if (savedMchInfo && savedMchInfo.mchNo) {
                  this.curMchInfo = savedMchInfo
                  this.$emit(
                    "chooseMch",
                    savedMchInfo,
                    this.mchList
                  );
                  this.currentSelectId = savedMchInfo.mchNo
                  this.$store.commit('SET_MCHINFO', savedMchInfo);
                  this.$actions.setGlobalState({
                    mchInfo: savedMchInfo
                  });
                } else {
                  this.$emit(
                    "chooseMch",
                    this.mchList[0],
                    this.mchList
                  );
                  this.currentSelectId = this.mchList[0].mchNo
                  this.curMchInfo = this.mchList[0]
                  setStore('mchInfo', JSON.stringify(this.mchList[0]))
                  this.$store.commit('SET_MCHINFO', this.mchList[0]);
                  this.$actions.setGlobalState({
                    mchInfo: this.mchList[0]
                  });
                }
              }
            } else {
              const mMchInfo = {
                mchName: null,
                mchNo: null,
                id: null,
                enterpriseCode: null,
                enterpriseName: null,
                keywords: null,
                status: null,
                type: null
              }
              this.mchList = []
              setStore('mchInfo', JSON.stringify(mMchInfo))
              this.$store.commit("SET_MCHINFO", mMchInfo);
              this.$actions.setGlobalState({
                mchInfo: mMchInfo
              });
            }
            if (this.isInit) {
              console.log('是执行了init函数的')
              this.$store.commit("SET_MCHLIST", this.mchList);
            }
            if (isSearch) {
              this.expanded = true
              this.$store.commit('SEARCH_MCH', true)
            }
          }
        } catch (error) {

        }
      }

    },
    fetchMch () {
      this.fetchMchList(true)
    },
    onChange () {
      this.isSelect = false
      this.isInit = false
      this.fetchMchList()
    },
    handleCancel () {
      this.$emit("closeMchSelect", false);
      this.searchName = ''
    },
    clickItem (event, item) {
      this.$store.commit('SEARCH_MCH', false)
      event.stopPropagation()
      this.currentSelectId = item.mchNo
      setStore('mchInfo', JSON.stringify(item))
      this.$emit('chooseMch', item, this.projectList)
      this.$emit("closeMchSelect", false);
      this.$store.commit("SET_MCHINFO", item);
      this.$actions.setGlobalState({ mchInfo: item });
      this.searchName = item.mchName
      location.reload()
    },
    handleExpand (event) {
      event.stopPropagation()
      if (this.mchList.length > 1) {
        this.expanded = !this.expanded
      }
    },
  }
}
</script>
<style>
.m-custom-project-select {
  max-height: 300px;
  overflow-y: auto;
  width: 240px;
}
.mm-project-select {
  width: 200px;
}
.mm-project-select > div {
  background: transparent;
  border: none;
}
.mm-project-select > div > div > div {
  font-weight: 500;
  font-size: 16px;
}
</style>
<style lang="less" scoped>
.pro-list {
  list-style: none;
  width: 280px;
  box-sizing: border-box;
  li {
    padding: 5px 16px;
    height: 32px;
    color: #262626;
    font-size: 14px;
    margin-bottom: 8px;
    cursor: pointer;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
}
.pro-search-header {
  width: 100%;
  padding: 12px 16px;
}
.no-project-data {
  height: 100px;
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}
.m-pro-ttip {
  font-weight: 500;
  font-size: 16px;
  line-height: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-around;
}
.dot-ent-name1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
.pro-select-contents {
  width: 100%;
  height: 56px;
  line-height: 56px;
}
.pro-drop-wrapper {
  position: absolute;
  z-index: 999999 !important;
  left: 18px;
  top: 66px;
  width: 280px;
  background: #ffffff;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.12), 0px 4px 16px rgba(0, 0, 0, 0.08),
    0px 6px 28px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  max-height: 368px;
  overflow-y: auto;
}
.pro-drop-wrapper-folding {
  left: 52px;
  top: 0;
}
.pro-select-wrapper {
  position: fixed;
  width: 226px;
  padding-left: 16px;
  padding-right: 12px;
  left: 0;
  top: 56px;
  z-index: 22;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fff;
  box-shadow: 13px 0 22px -12px rgba(0, 0, 0, 0.1);
}
.pro-select-wrapper1 {
  position: fixed;
}
.pro-select-wrapper-folding {
  width: 50px;
  padding: 0;
}
.entprise-select-search {
  width: 294px;
  margin-bottom: 16px;
}
.entprise-select-dialog {
  .business-modal-content {
    width: 750px;
  }
}
.entprise-select-list {
  margin-left: 0;
  padding-left: 0;
}
.entprise-select-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 6px 8px;
  .entprise-select-name {
    flex: 1;
    color: #262626;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
  }
  .entprise-select-icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    background: url('~@/assets/images/common/ent-select-icon.png') no-repeat
      center;
    background-size: 100%;
    margin-right: 8px;
  }
}
</style>